module.exports = __webpack_public_path__ + "static/assets/11b9f4fc432abfafecf0e25e1cfb1d87.svg";